import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  Grid,
  ListItemButton,
  Stack,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_CHANGE_TRACKER, FETCH_CLIENT_EMP_JOBS_2 } from "../../constant/Apipath";
import { BILightGrey } from "../../assets/helpers";
import ChangeTrackerListView from "./ChangeTrackerListView";
import ClientChangeTrackerAddModel from "./ClientChangeTrackerAddModel";
import { ClientChangeTrackerViewModel } from "./ClientChangeTrackerViewModel";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useLocation } from "react-router-dom";

export default function ClientChangeTracker() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientChangeTracker(
    multiLanguageData?.ClientChangeTracker || {}
  );
  const { TEXT_NO_DATA } = LANGUAGE;
  const [isLoading, setLoading] = useState(false);
  const [addModel, setAddModel] = useState(false);
  const [addModelData, setAddModelData] = useState({});
  const [listingLoading, setListingLoading] = useState(false);
  const [sortedData, setSortedData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    fetchJobs();
  }, [location]);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_EMP_JOBS_2, obj, loginData?.accessToken);

      if (res?.status === 200) {
        const data = res?.data?.data;
        setLoading(false);
        setSortedData(data);

        setListingLoading(true);
        const promises = data?.map(async (item, index) => {
          let jobObj = {
            PageNr: 1,
            NrOfRecPerPage: 3,
            FullSearch: "",
            UserId: loginData?.userInformation?.UserId,
            IncludeRecordNr: true,
            FetchAllowedRecordsOnly: true,
            SortList: [{ FieldName: "dateCreated", Direction: "DESC" }],
            SearchList: [
              {
                clientEmployeeJobId: item?.id
              }
            ]
          };

          try {
            let a = await Postrequestcall(
              FETCH_CLIENT_CHANGE_TRACKER,
              jobObj,
              loginData?.accessToken
            );
            return {
              ...item,
              data: a?.data?.data || [],
              nrOfRecords: a?.data?.nrOfRecords || 0
            };
          } catch (error) {
            console.error("fetchJobs-> Error Fetching Job: ", error);
          }
        });

        let ctData = await Promise.all(promises);

        const trackerData = ctData?.map((item) => {
          const trackerResult = ctData?.find((result) => result.jobCode === item.jobCode);

          return {
            ...item,
            noOfRecords: trackerResult?.nrOfRecords || 0
          };
        });

        const sortedData = trackerData.sort((a, b) => {
          const dateA = moment(a?.data?.[0]?.dateCreated || 0);
          const dateB = moment(b?.data?.[0]?.dateCreated || 0);
          return dateB.valueOf() - dateA.valueOf();
        });
        setListingLoading(false);

        setSortedData(sortedData);
      }
    } catch (error) {
      console.error("fetchJobs-> Error Fetching Jobs: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid size={12} container spacing={1}>
        {isLoading ? (
          <Stack
            style={{
              width: "100%"
            }}
            sx={{ alignItems: "center" }}>
            <Loader fullScreen={true} />
          </Stack>
        ) : (
          <>
            {sortedData?.length === 0 ? (
              <Stack sx={{ width: "100%", height: "85vh", justifyContent: "center", alignItems: "center" }}>
                <Typography>{TEXT_NO_DATA}</Typography>
              </Stack>
            ) : (
              <>
                {sortedData?.map((item, index) => (
                  <Grid key={index} size={12}>
                    <Accordion defaultExpanded>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        sx={{
                          "& .MuiAccordionSummary-content": {
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "0 !important",
                            paddingRight: "16px",
                          },
                        }}>
                        <Stack direction={"row"} sx={{ alignItems: "center" }}>
                          <LocationOnIcon
                            sx={{
                              color: selectedClientData?.AccentColor,
                              mr: 1
                            }}
                          />
                          <Typography sx={{ padding: 0, margin: 0, fontSize: 16 }} variant="subtitle2">
                            {`${item?.jobCode} - ${item?.jobName}`}
                          </Typography>
                        </Stack>

                        <div
                          onClick={(e) => {
                            e?.stopPropagation();
                            setAddModel(true);
                            setAddModelData(item);
                          }}
                          style={{
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                          }}>
                          <AddIcon
                            sx={{
                              color: selectedClientData?.AccentColor
                            }}
                          />
                        </div>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          padding: "10px"
                        }}>
                        <Listing
                          data={item}
                          listingLoader={listingLoading}
                          index={index}
                          key={index}
                        />
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                ))}
              </>
            )}
          </>
        )}
      </Grid>
      {addModel && <ClientChangeTrackerAddModel
        isOpen={addModel}
        onClose={() => setAddModel(false)}
        data={addModelData}
        reload={(id) => fetchJobs()}
      />}
    </>
  );
}

const Listing = (props) => {
  const { data, listingLoader } = props;
  const [viewModal, setViewModal] = useState(false);
  const [onCLickData, setOnCLickData] = useState(null);
  const [jobData, setJobData] = useState(null);
  const [listViewModal, setListViewModal] = useState(false);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientChangeTracker(
    multiLanguageData?.ClientChangeTracker
  );

  const { TEXT_SEE_MORE, TEXT_NO_REQUEST_AVAILABLE } = LANGUAGE;
  return (
    <>
      <Grid size={12} container spacing={1}>
        {listingLoader ? (
          <>
            <Stack
              style={{
                width: "100%"
              }}
              sx={{ alignItems: "center" }}>
              <Loader />
            </Stack>
          </>
        ) : data?.data?.length !== 0 ? (
          <>
            {data?.data?.map((item, index) => {
              return (
                <Grid
                  key={index}
                  size={12}
                  style={{
                    padding: "0",
                    borderRadius: "10px",
                    border: "1px solid #e4e4e4"
                  }}>
                  <ListItemButton
                    onClick={() => {
                      setViewModal(true);
                      setOnCLickData(item);
                    }}
                    style={{
                      padding: "0",
                      borderRadius: "10px"
                    }}>
                    <Grid sx={{ padding: 1 }} size={12}>
                      <Stack
                        direction={"row"}
                        sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 1.5 }}
                        >
                        <Avatar src={item?.userProfilePicture} />
                        <Stack sx={{ flexGrow: 1, width: "100%" }} direction="column">
                          <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction="row">
                            <Typography sx={{ fontSize: 15 }} variant="subtitle2">
                              {item?.clientEmployeeName}
                            </Typography>
                            <Typography
                              style={{
                                color: "grey"
                              }}>
                              {dayjs(item?.date).format("MMMM DD, YYYY")}
                            </Typography>
                          </Stack>
                          <Typography
                            sx={{
                              wordBreak: "break-all",
                              display: "-webkit-box",
                              overflow: "hidden",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1
                            }}>
                            {item?.description}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </ListItemButton>
                </Grid>
              );
            })}
            {data?.nrOfRecords > 3 && (
              <Button
                onClick={() => {
                  setListViewModal(true);
                  setJobData(data);
                }}
                fullWidth
                style={{
                  backgroundColor: BILightGrey,
                  color: "black",
                  textTransform: "none"
                }}>
                {/* DO DATA ENTRY OF BELOW TEXT */}
                {`${TEXT_SEE_MORE?.split(" ")?.[0]} ${data?.nrOfRecords - 3} ${TEXT_SEE_MORE?.split(" ")?.slice(1)?.join(" ")}`}
              </Button>
            )}
          </>
        ) : (
          <>
            <Typography sx={{
              width: "100%",
              textAlign: "center"
            }}>{TEXT_NO_REQUEST_AVAILABLE}</Typography>
          </>
        )}
      </Grid>
      <ChangeTrackerListView
        open={listViewModal}
        onClose={() => setListViewModal(false)}
        data={jobData}
        loginData={loginData}
      />
      <ClientChangeTrackerViewModel
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
        data={onCLickData}
      />
    </>
  );
};
